import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {searchSupplierOrders} from "./actions";
import ListView from "../common/ListView";
import {Button} from "antd";
import DateTimeDisplay from "../common/DateTimeDisplay";

class SupplierOrdersPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string,
    search: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* actions */
    searchSupplierOrders: PropTypes.func.isRequired,
  };

  static defaultProps = {
    salonId: null
  };

  render() {
    const {
      history, salonId, searchSupplierOrders,
      search: {searching, pagination, filters, sorter, results, searchFilter},
      match: {params: {supplierId}}
    } = this.props;
    const columns = [
      {
        title: 'Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        fixed: 'left',
        render: (createdAt) => <DateTimeDisplay dateTime={createdAt}/>,
        width: 165,
      },
      {
        title: 'Items',
        dataIndex: 'items',
        key: 'items',
        render: (items) => items.length
      },
      {
        title: 'Received',
        dataIndex: 'received',
        key: 'received',
        render: (received, supplierOrder) => {
          if (received) return 'Yes';
          const r = supplierOrder.items.reduce((a, v) => a + (v.received >= v.quantity ? 1 : 0), 0);
          if (r > 0) return `Partially (${r} of ${supplierOrder.items.length} items)`;
          return 'No';
        }
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 110,
        render: (_, supplierOrder) => {
          return (
            <React.Fragment>
              <Link to={`/supplier/order/${encodeURIComponent(supplierOrder.supplierOrderId)}`}>Receive</Link>
            </React.Fragment>
          );
        },
      }
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          " Supplier Orders"
        ]}
        loading={searching}
        columns={columns}
        dataSourceProvider={searchSupplierOrders}
        dataSource={results}
        pagination={pagination}
        filters={{...filters, supplierId}}
        sorter={sorter}
        searchFilter={searchFilter}
        salonId={salonId}
        rowKey="supplierOrderId"
      />
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  search: state.supplier.ordersSearch,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchSupplierOrders,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(SupplierOrdersPage);



// WEBPACK FOOTER //
// ./src/Supplier/SupplierOrdersPage.js